<script>
import { componentStore } from "@common/componentStore/componentStore";

let testDataListConfig = {
    cId: "testDataList",
    cType: "testDataList",
    cTitle: "Test Data List",
    cTemplate: `<div class="test-data-list">
                    <control name="TEST_DATA_LIST" :items="testDataList"></control>
                    <div class="new-dataset-button">
                        <control name="NEW_TEST_DATA"></control>
                    </div>
                </div>`,
    controls: [
        {
            name: 'TEST_DATA_LIST',
            type: "dropdown",
            placeholder: "Select Test Data",
            onchange: "selectTestData",
            filterBarPlaceholder: "Search here",
            popupHeight: "220px",
            allowFiltering: true,
            fields: { text: 'text', value: 'value' },
        },
        {
            name: 'NEW_TEST_DATA',
            type: 'button',
            label: 'New Test Dataset',
            onclick: 'newTestData',
            cssClass: "e-block e-info",
        }
    ],
    layoutDatamap: [
        {
            "property": "selectedTestDataId", "from": "testDataList", "to": "thisStore", "as": "selectedTestDataId"
        },
        {
            "property": "createNewTestDataset", "from": "testDataList", "to": "thisStore", "as": "createNewTestDataset"
        },
    ]
};

let testDataListCmp = {
    name: 'testDataList',
    props: {
        reloadList: {
            default: false
        }
    },
    data() {
        return {
            selectedTestDataId: false,
            createNewTestDataset: false,
            testDataList: null
        };
    },
    methods: {
        onMappedDataUpdate(property) {
            if (property === 'reloadList' && this.reloadList) {
                this.onLoad();
            }
        },
        onLoad() {
            let prevSelectedTestDataId = this.selectedTestDataId;
            this.selectedTestDataId = false;
            componentStore.getTestDataKeys().then((data) => {
                if (Array.isArray(data)) {
                    let dataKeys = [];
                    for (let i in data) {
                        if (i === 'length') continue;
                        dataKeys.push({
                            'text': data[i]['cType'] + ': ' + data[i]['key'],
                            'value': data[i]['key']
                        });
                    }
                    this.testDataList = dataKeys;
                    if (prevSelectedTestDataId) this.selectedTestDataId = prevSelectedTestDataId;
                }
            });
        },
        selectTestData: function (item) {
            this.createNewTestDataset = false;
            this.selectedTestDataId = item.value;
        },
        newTestData() {
            this.selectedTestDataId = false;
            this.createNewTestDataset = true;
        }
    }
};

componentStore.initComponent(testDataListCmp, testDataListConfig);
export { testDataListConfig, testDataListCmp };
export default testDataListCmp;
</script>
<style>
    .new-dataset-button {
        margin-top: 10px;
    }
</style>
